angular.module('property-price-list')
    .controller('PropertyPriceListDialogController', function ($window, $rootScope, $state, toastr, data, Project, Property, PropertyService, PropertyPriceList, PropertyPriceListService, PropertyPriceListImportService) {
        this.item = data
        this.PropertyService = PropertyService
        this.PropertyPriceListService = PropertyPriceListService

        this.$onInit = () => {
            this.statuses = PropertyPriceList.statuses()
            this.calculationMethods = Property.calculationMethods()
            this.calculationBasedOn = [ 'BASE', 'TOTAL' ]
            this.attributes = Property.attributes()
            this.pricingStrategies = Property.pricingStrategies()
            this.attributeTypes = PropertyService.attributeTypes()
        }
        this.cancel = () => $window.history.back()

        this.import = () => {
            PropertyPriceListImportService.import(this.item.project.id, this.item.attributes).then(result => this.item.items = result)
        }

        this.deleteAttribute = (attribute, $attributeIndex) => {
            this.item.attributes.splice($attributeIndex, 1)
            this.item.items.forEach(property => {
                property.attributes = property.attributes.filter(a => a.attribute !== attribute)
                property.extraCharges = property.extraCharges.filter(a => a.attribute !== attribute)
            })
        }

        this.onProjectChanged = () => {
            let project = this.item.project
            if (!project) {
                delete this.item.items
                delete this.item.attributes
                delete this.item.extraCharges
                return
            }

            Project.attributes({id: project.id}).$promise.then(projectAttributes => {
                this.item.attributes = projectAttributes.map(projectAttribute => {
                    return {
                        attribute: projectAttribute.name,
                        strategy: projectAttribute.pricingStrategy,
                        type: projectAttribute.type
                    }
                })
            })
            Project.properties({id: project.id}).$promise.then(result => {
                this.item.items = result.map(property => {
                    let priceListProperty = {
                        propertyId: property.id,
                        number: property.number,
                        finalNumber: property.finalNumber,
                        property_uid: property.property_uid,
                        type: property.type,
                        techType: property.techType,
                        floor: property.floor,
                        rooms: property.rooms,
                        windowSide: property.windowSide,
                        livingArea: property.livingArea,
                        livingAreaFinal: property.livingAreaFinal,
                        calculationBasedOn: property.calculationBasedOn,
                        calculationMethod: property.calculationMethod,
                        vat: property.vat,
                        pricingBase: property.pricingBase,
                        pricingAttributes: property.pricingAttributes,
                        pricingExtraCharges: property.pricingExtraCharges,
                        pricing: property.pricing
                    }

                    priceListProperty.attributes = property.attributes.map((attribute) => {
                        delete attribute.id
                        return attribute
                    })
                    priceListProperty.extraCharges = property.extraCharges.map((it) => {
                        delete it.id
                        return it
                    })

                    if (property.building) {
                        priceListProperty.buildingId = property.building.id
                        priceListProperty.buildingNumber = property.building.number
                        priceListProperty.buildingFloors = property.building.floors
                    }

                    return priceListProperty
                })
            })
        }

        this.save = () => {
            let toSave = angular.copy(this.item);
            if (this.item.id !== null) {
                this.savingPromise = PropertyPriceList.update(toSave, onSaveSuccess, () => {});
            } else {
                this.savingPromise = PropertyPriceList.save(toSave, onSaveSuccess, () => {});
            }
        }

        let onSaveSuccess = result => {
            $rootScope.$broadcast('property-price-list.updated');
            toastr.success("Zapisano");
            $state.go('propertyPriceList');
        };
    })
